import React from "react";
import { Link, useLocation } from "react-router-dom";
import "styles/panel.css";
import { adminMenuItems } from "config/menuConfig";

const AdminSidebar = () => {
  const location = useLocation();

  return (
    <aside className="admin-sidebar">
      <div className="admin-logo">
        <h2>Algoritm Admin</h2>
      </div>

      <nav className="admin-menu">
        {adminMenuItems.map((item) => {
          const isActive =
            location.pathname === item.path ||
            location.pathname.startsWith(item.path + "/");

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`admin-menu-item ${isActive ? "active" : ""}`}
            >
              <span className="icon">{item.icon}</span>
              <span className="label">{item.name}</span>
            </Link>
          );
        })}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
